/**
 * Whether `value` is a string with at least one non-whitespace character.
 */
export function isNonEmptyString(
	value: string | null | undefined,
): value is string {
	return typeof value === 'string' && value.trim() !== '';
}
